import axios from 'axios'
import {API_URL} from '../crud-helper/helpers'

const isProtectedLegacySource = (source: string) =>
  source.includes('/file-library/file/') || source.includes('/file-library/ticket-file/')

export const getAttachmentFileUrl = (source: string) => {
  if (/^https?:\/\//i.test(source)) return source
  if (source.startsWith('/api/')) return `${API_URL}${source.substring(4)}`
  if (source.startsWith('/ticketing/') || source.startsWith('/file-library/')) {
    return `${API_URL}${source}`
  }
  return `${API_URL}/upload?load=${encodeURIComponent(source)}`
}

export const openAttachmentFile = async (source: string, fileName: string, inline = false) => {
  const url = getAttachmentFileUrl(source)

  if (!isProtectedLegacySource(url)) {
    if (inline) {
      window.open(url, '_blank', 'noopener,noreferrer')
      return
    }
    const link = document.createElement('a')
    link.href = url
    link.download = fileName || 'attachment'
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
    document.body.appendChild(link)
    link.click()
    link.remove()
    return
  }

  const response = await axios.get(url, {responseType: 'blob'})
  const blobUrl = window.URL.createObjectURL(response.data as Blob)
  if (inline) {
    window.open(blobUrl, '_blank', 'noopener,noreferrer')
    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60_000)
    return
  }

  const link = document.createElement('a')
  link.href = blobUrl
  link.download = fileName || 'attachment'
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1_000)
}
